import { ErrorMessage, MUIIcon, Spinner } from "../../../../../widgets";
import { FC, useCallback } from "react";
import { FetchStatus, Property } from "../../../../../base/types";

import { IControlAttributes } from "../../../../../base/models";
import { useHiddenValueProperties } from "./HiddenValueProperties";

export const DraftHiddenValueComponent: FC<IControlAttributes> = ({
    props
}) => {
    const { status, bindings, error } = useHiddenValueProperties(props);

    const getValue = useCallback(() => {
        if (!bindings) return;

        const binding = bindings.getBinding(Property.InitValue);
        if (!binding || !binding.boundValue) return;

        switch (binding.type) {
            case "Const":
                return `"${binding.boundValue}"`
            case "Expression":
                return `${binding.boundValue?.query}`
            case "Field":
                return `{${binding.boundValue}}`
        }
    }, [bindings])

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    const value = getValue()

    return <>
        <div className="alert alert-warning bg-gray mb-0 p-0 rounded-0 d-flex flex-wrap align-items-center">
            <div className={"badge badge-warning text-nowrap rounded-0 fs-9"}>
                <MUIIcon iconName="VisibilityOffOutlined" className="me-1" />
                <span>Hidden</span>
            </div>
            <div className="fs-9 fw-bold fst-italic px-1">
                {value}
            </div>
        </div>
    </>
}